module.exports = __webpack_public_path__ + "img/rooms.d9e6d9e8.svg";